var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEyeOff = function SvgIconEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.969 11.547a2.188 2.188 0 0 1-1.737.632L12.6 9.81a2.188 2.188 0 0 1-.632 1.737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m16.828 2.4.835.834a.157.157 0 0 1 0 .22l-13.91 13.91a.157.157 0 0 1-.22 0l-.835-.835a.156.156 0 0 1 0-.22l2.067-2.066c-1.04-.938-1.93-2.184-2.667-3.74a1.178 1.178 0 0 1 0-1.005c1.847-3.91 4.648-5.865 8.402-5.865 1.47 0 2.794.3 3.972.903L16.607 2.4a.156.156 0 0 1 .221 0M7.431 8.306a3.438 3.438 0 0 0-.042 3.313l.95-.95a2.19 2.19 0 0 1 2.752-2.752l.95-.95a3.437 3.437 0 0 0-4.61 1.339",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.447 5.954c.95.914 1.768 2.094 2.455 3.542a1.177 1.177 0 0 1 0 1.006c-1.847 3.91-4.648 5.865-8.402 5.865-1.357 0-2.589-.256-3.697-.769l2.388-2.388a3.439 3.439 0 0 0 4.441-4.44z"
  })));
};
export default SvgIconEyeOff;